import { Link } from 'react-router';
import { Badge, StatusBadge } from '../../../ui/Badge';
import { Card } from '../../../ui/misc';
import type { ReleaseDetail } from '../types';

export function TicketReadiness({ r, projectKey }: { r: ReleaseDetail; projectKey: string }) {
  const key = projectKey;
  return (
    <Card title="Tickets and readiness">
      <div className="table-wrap">
        <table className="table">
          <thead>
            <tr>
              <th>Ticket</th>
              <th>Status</th>
              <th>Scope rev</th>
              <th>Readiness revision</th>
              <th>Reservation</th>
            </tr>
          </thead>
          <tbody>
            {r.tickets.map((t) => {
              const s = r.candidate?.snapshot?.tickets.find((x) => x.key === t.key);
              return (
                <tr key={t.key}>
                  <td>
                    <Link to={`/projects/${key}/tickets/${t.number}`} className="mono">
                      {t.key}
                    </Link>{' '}
                    {t.title}
                  </td>
                  <td>
                    <StatusBadge status={t.status as never} resolution={t.resolution as never} />
                  </td>
                  <td>{s?.scopeRevision ?? '—'}</td>
                  <td className="mono small">{s?.sourceRevision?.slice(0, 12) ?? '—'}</td>
                  <td>
                    {t.reserved ? (
                      <Badge tone="info" dot={false}>
                        Reserved
                      </Badge>
                    ) : (
                      <span className="muted small">Released</span>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
